import Targets from './Targets'
import List from './children/list'
import New from './children/New'
import Edit from './children/Edit'
import BulkEditing from './children/BulkEditing'
import Target from './children/Target'
import { LinkTags } from './children/components/target/side-menu/tag'
import { SuggestGoal, FocalPoint } from './children/components/target/tab-content/settings/components'

export default Targets
export { List, New, Edit, Target, LinkTags, SuggestGoal, FocalPoint, BulkEditing }
